import hres72uLabels from 'assets/labels/hres72u'
import faker from 'faker'
import moment from 'moment'
import labels from 'src/../config/label.js'

export const mocker = {
  labels () {
    return {
      labels: hres72uLabels
    }
  },
  index () {
    let mockRows = []
    let staappr = ''
    const mockStaappr = [ 'P', 'Y', 'N', 'A', 'C' ]
    const mockStatus = {
      'P': 'รอพิจารณา',
      'Y': 'อนุมัติ',
      'N': 'ไม่อนุมัติ',
      'A': 'ระหว่างอนุมัติ',
      'C': 'ยกเลิก'
    }
    const mockTotal = 5
    for (var i = 1; i <= mockTotal; i++) {
      staappr = mockStaappr[Math.floor(Math.random() * 5)]
      mockRows.push({
        id: i,
        codempid: faker.lorem.word(),
        desc_codempid: faker.name.findName(),
        desc_typpayroll: faker.lorem.words(),
        dtereq: moment().format('DD/MM/YYYY'),
        numseq: faker.random.number().toString().substr(0, 1),
        amtreq: faker.commerce.price(),
        amtalw: faker.commerce.price(),
        staappr: '',
        status: mockStatus[staappr],
        desc_codappr: faker.name.findName(),
        dteappr: moment().format('DD/MM/YYYY'),
        remarkap: faker.lorem.words(),
        desc_codempap: faker.name.findName(),
        approvno: faker.random.number().toString().substr(0, 1),
        chk_appr: '',
        typpatient: '',
        codrel: ''
      })
    }

    return {
      total: mockTotal,
      rows: mockRows
    }
  },
  detail () {
    let mockTab1 = {
      dtereq: moment().format('DD/MM/YYYY'),
      desc_codrel: faker.lorem.word(),
      namsick: faker.name.findName(),
      desc_codcln: faker.lorem.word(),
      desc_coddc: faker.lorem.word(),
      desc_typpatient: faker.lorem.word(),
      desc_typamt: faker.lorem.word(),
      flgdocmt: faker.lorem.word(),
      filenam1: faker.lorem.word(),
      path_filenam1: faker.lorem.word(),
      filenam2: faker.lorem.word(),
      path_filenam2: faker.lorem.word(),
      filenam3: faker.lorem.word(),
      path_filenam3: faker.lorem.word(),
      amtreq: faker.commerce.price(),
      dtecrest: moment().format('DD/MM/YYYY'),
      dtecreen: moment().format('DD/MM/YYYY'),
      qtydte: faker.random.number().toString().substr(0, 1),
      typpay: faker.lorem.word(),
      remarkap: faker.lorem.word(),
      codrel: faker.lorem.word(),
      codcln: faker.lorem.word(),
      coddc: faker.lorem.word(),
      typpatient: faker.lorem.word(),
      typamt: faker.lorem.words()
    }
    let mockTab2Rows = []
    const mockTab2Total = 6
    for (var i = 1; i <= mockTab2Total; i++) {
      mockTab2Rows.push({
        id: i,
        coddcal: faker.lorem.word(),
        desc_coddcal: faker.lorem.words(),
        amtreq: faker.commerce.price(),
        amtalw: faker.commerce.price(),
        coduser: '53100',
        codempid: '53100',
        codcln: '1',
        codrel: '1'
      })
    }
    // let mockPopupTab2 = {
    //   syncond: faker.lorem.words(),
    //   desc_coddcal: faker.lorem.word(),
    //   desc_typcal: faker.lorem.word(),
    //   desc_typcln: faker.lorem.word(),
    //   amtmaxn: faker.commerce.price()
    // }
    let mockTab3 = {
      syncond: faker.lorem.words(),
      flgprorate: faker.lorem.words(),
      desc_typamt: faker.lorem.word(),
      amtwidrwy: faker.commerce.price(),
      qtysum: faker.commerce.price(),
      amtalw: faker.commerce.price(),
      qtywidrwy: faker.random.number().toString().substr(0, 1),
      amtwidrwt: faker.random.number().toString().substr(0, 1)
    }

    return {
      tab1: mockTab1,
      tab2: {
        table: {
          total: mockTab2Total,
          rows: mockTab2Rows
        },
        popup: {}
      },
      tab3: mockTab3
    }
  },
  detailSubmit () {
    let mockTab1 = {
      staappr: '',
      flgStaappr: '',
      approvno: '1',
      chk_appr: '',
      numseq: '1',
      dtereq: moment().format('DD/MM/YYYY'),
      codempid: faker.lorem.word(),
      desc_codempid: faker.lorem.words(),
      codappr: faker.lorem.word(),
      desc_codappr: faker.lorem.word(),
      dteappr: moment().format('DD/MM/YYYY'),
      amtalw: '',
      status: faker.lorem.words(),
      remark: faker.lorem.words()
    }
    return {
      tab1: mockTab1
    }
  },
  approve () {
    return {
      codempid: faker.lorem.word(),
      desc_codempid: faker.lorem.words(),
      numseq: faker.random.number().toString().substr(0, 1),
      codappr: faker.lorem.word(),
      desc_codappr: faker.lorem.word(),
      dteappr: moment().format('DD/MM/YYYY'),
      amtalw: faker.commerce.price(),
      status: faker.lorem.words(),
      remark: faker.lorem.words(),
      staappr: ''
    }
  },
  detailTab2Popup () {
    return {
      syncond: faker.lorem.words(),
      desc_coddcal: faker.lorem.word(),
      desc_typcal: faker.lorem.word(),
      desc_typcln: faker.lorem.word(),
      amtmaxn: faker.commerce.price()
    }
  },
  sendApprove () {
    return labels.mockPostMessage
  }
}



// WEBPACK FOOTER //
// ./src/api/hres72u/mocker.js